<template>
    <v-dialog v-model="dialog" persistent fullscreen
    >
        <v-layout align-center justify-center row fill-height
                  :style="{ backgroundImage: 'url(' + require('@/assets/img/login-bkg.jpg') + ')' }"
                  style="background-size: cover">
            <v-card style="min-width:800px; opacity: 80%">
                <v-card-title class="accent white--text title">
                    <img v-if="brandName=='JEC'" class="cursor-as-pointer" :src="require('@/assets/img/logojec.jpg')"
                         height="50"/>
                    <span v-if="brandName!=='JEC'">{{ brandName }}</span>
                    <strong class="ml-3"> {{facilityName}}</strong> <span class="ml-2"> - {{ 'Dashboard Setup'|translate }}</span>
                </v-card-title>
                <v-card-text v-if="!$can('update', 'Config')">
                    <v-alert :value="true" type="error">
                        {{ 'Not logged in as administrator'|translate }}
                    </v-alert>
                </v-card-text>
                <v-card-actions v-if="!$can('update', 'Config')">
                    <v-spacer></v-spacer>
                    <v-btn color="#505050" large @click="logout">{{'Log Out'|translate}}</v-btn>
                </v-card-actions>
                <v-card-text v-if="$can('update', 'Config')">
                    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                    <v-layout wrap align-center justify-center v-if="!menuConfig">
                        <v-flex v-for="(value,key) in menuPresets" xs3>
                            <v-hover v-slot:default="{ hover }">
                                <v-card
                                    class="pa-2 ma-2 cursor-as-pointer"
                                    @click="runSetup(value)"
                                    :elevation="hover ? 12 : 2"
                                    :class="{ 'on-hover': hover }">
                                    <h3 class="mx-4 layout justify-center"> {{ key }} </h3>
                                </v-card>
                            </v-hover>
                        </v-flex>
                    </v-layout>
                    <v-alert :value="true" type="info" v-if="menuConfig">
                        {{ 'Dashboard setup complete'|translate }}
                    </v-alert>
                </v-card-text>
                <v-card-actions class="justify-center pb-8" v-if="!loading&&menuConfig">
                    <v-spacer></v-spacer>
                    <v-btn color="#505050" large @click="redirectHome">{{'Back to Home'|translate}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-layout>
    </v-dialog>
</template>

<script>
import { msalMixin } from "vue-msal";
import {getConfig, putConfig, uniqueid} from '../helper'
import { mapGetters } from 'vuex'
import preset from '../config/pccv/generic.js'
import menuPreset from '../config/menuPresets/generic.js'

export default {
    name: 'Setup',
    mixins: [msalMixin],
    props: {},
    data() {
        return {
            dialog: false,
            loading: true,
            presets: preset,
            menuPresets: menuPreset,
            config: [],
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'publishedCustomViews','menuConfig'
        ]),
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        brandName() {
            if (localStorage.getItem('brandingOverride') == '1') {
                return "Carnot Innovations"
            }
            return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
        },
    },
    async mounted() {
        this.dialog = true
        let df = await getConfig({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.config = df['result']
        this.loading = false
    },
    methods: {
        logout () {
            if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
                this.$msal.signOut()
            } else {
                localStorage.setItem('pass', '')
                window.location.href="/login";
            }
        },
        async runSetup(items){
            let newMenu=JSON.parse(JSON.stringify(items))
            this.loading=true
            for (let item of newMenu){
                if(item.preset){
                    item.to="/custom-view/" + await this.createCustomView(item.preset)
                }
                delete item.preset
                if (item.children){
                    for (let child of item.children){
                        if(child.preset){
                            child.to="/custom-view/" + await this.createCustomView(child.preset)
                        }
                        delete child.preset
                    }
                }
            }
            await putConfig(
                {
                    'config_id': null,
                    'config_name': "menuConfig",
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'config': JSON.stringify(newMenu),
                }
            )
            await this.$store.dispatch('refreshConfig',{facility_name: this.$store.state.pointsListStore.pointsList.facility_name})
            this.loading=false
            this.redirectHome()
        },
        redirectHome() {
            window.location.href="/"
        },
        async createCustomView(key) {
            let plotlist=JSON.parse(JSON.stringify(this.presets[key]["plotList"]))
            for (let plot of plotlist){
                plot.editDialog = false
                plot.id = uniqueid()
            }
            let newPlot = {
                id: uniqueid(),
                viewType: "plot-list",
                facility: this.$store.state.pointsListStore.pointsList.facility_name,
                title: this.presets[key]["title"],
                linkTitle: this.presets[key]["linkTitle"],
                plotList: plotlist,
                published: true
            }
            await this.$store.dispatch('addUserPlot', newPlot)
            return newPlot.id
        },
    }
}
</script>

<style scoped>

</style>
